<template>
  <div>
    <RevTooltip position="right">
      <template #trigger="{ hide, show }">
        <span
          class="body-2-bold text-static-success-hi underline cursor-pointer"
          role="button"
          tabindex="0"
          @click="show"
          @focusin="show"
          @focusout="hide"
          @keydown.enter="show"
          @keydown.space="show"
          @mouseenter="show"
          @mouseleave="hide"
        >
          {{
            i18n(translations.flashSalesDiscount, {
              discount: i18n.price(normalizePrice(discount), {
                trailingZeroDisplay: 'stripIfInteger',
              }),
            })
          }}
        </span>
      </template>
      {{ i18n(translations.flashSalesDiscountTooltip) }}
    </RevTooltip>
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/core-types/Price'
import type { PriceNumber } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTooltip } from '@ds/components/Tooltip'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './FlashSalesTooltip.translations'

defineProps<{
  discount: Price | PriceNumber
}>()

const i18n = useI18n()
</script>
